<template>
  <div class="animated fadeIn list-of-vendor">
    <b-card>
      <div slot="header">Vendor/Supplier List  
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="12">
            <b-input-group>
                <b-input-group-prepend><span class="p-2">Filter</span></b-input-group-prepend>
                  <b-form-input v-model="tblData.bussinesgroup" @keyup.13.native="search()" placeholder="Bussines Group" style="width:23% !important;"></b-form-input>
                  <b-form-input v-model="tblData.vendor_name" @keyup.13.native="search()" placeholder="Vendor Name" class="ml-1" style="width:23% !important;"></b-form-input>
                  <b-form-input v-model="tblData.vendor_code" @keyup.13.native="search()" placeholder="Vendor Code" class="ml-1"></b-form-input>
                <b-input-group-append>
                    <b-button class="btn btn-success ml-1" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear </b-button>
                </b-input-group-append>
            </b-input-group>
        </b-col>
    </b-row>                      
        <b-table
          class="mb-0"
          ref="tblVendor"
          responsive outlined
          striped hover 
          style="font-size:smaller;" 
          :items="data"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
        >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;" >Edit</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;" > Delete</b-dropdown-item>
        </b-dropdown>
      </template>        
          <template v-slot:cell(vendor_phone)="data">
            <span v-if="(data.item.vendor_phone)">P.{{data.item.vendor_phone}}</span>&nbsp;
            <span v-if="(data.item.vendor_fax)">F.{{data.item.vendor_fax}}</span>
          </template>
          <template v-slot:cell(vendor_address1)="data">
            {{data.item.vendor_address1}} {{data.item.vendor_address2}} {{data.item.vendor_city}}
          </template>

        </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page" class="mb-0">
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss">
  .list-of-vendor {
    table {
      td {
        .dropdown-item {
            padding: 0.1rem 1.5rem !important;
            font-size: smaller !important;
        }    
      }
    }
 }
</style>

<script>
import vendor from "../../apis/vendor";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      fields: [
        {
          key: "action",
          label: "",
          thClass: "text-center",
        },
          {
            key: "vendor_code",
            label: "Vendor Code",
            sortable: true
          },
          {
            key: "vendor_name",
            thStyle: "width:250px",
            label: "Vendor Name",
            sortable: true
          },
          {
            key: "bussinesgroup",
            label: "Bussines Category",
            sortable: true
          },
          {
            key: "vendor_phone",
            label: "Phone/Fax",
          },
          {
            key: "vendor_address1",
            label: "Address"
          },
          {
            key: "npwp",
            label: "N P W P",
          },
          {
            key: "npwp_name",
            label: "Nama WP",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
      },
      limit:15,
      pagination: false,
      namamenu: '',
      model:{},
      showDelConfirm: false,
      horizontal: true,
      showFilter:false,
      isLoading:false,
      showReport:false,
      reportUrl: null
    };
  },
  components :{Loading},
  created: async function() {
      this.namamenu=this.$route.name;
  },
  watch:{
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },      
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.vendlist) {
            this.tblData[key] = filter.vendlist[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.vendlist.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.vendlist;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await vendor.list(this.tblData);
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }
        } else {
            this.isLoading=true;
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            try {
              const list = await vendor.list(this.tblData);
              this.pagination=true;
              this.isLoading=false;  
              return list;        
            } catch (error) {
              this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
            }
        }
    },

    selectItem(record,index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    refresh() {
      this.$refs.tblVendor.refresh();
    },
    search() {
      this.tblData.page=1
      this.$refs.tblVendor.refresh();
    },

    clearFilter(ctx) {
        this.tblData.vendor_code = '';
        this.tblData.vendor_name =  '';
        this.tblData.bussinesgroup = '';
        this.tblData.contact =  '';
        this.refresh();
    },    
    saveFilter() {
      const keys = ['sortBy', 'sortDir', 'vendor_code', 'vendor_name', 'vendor_address1', 'vendor_city', 'bussinesgroup', 'contact'];
      let filtered = false;
      const vendlist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              vendlist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          vendlist.page=this.tblData.page;
          vendlist.limit=this.tblData.limit;
          vendlist.sortBy=this.tblData.sortBy;
          vendlist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.vendlist=vendlist;
          this.$store.commit("filter", filter);
      }
    },   
    rowEdit(record) {
      this.selectItem(record);
      this.edit();
    },
    rowDel(record) {
      this.selectItem(record);
      this.deleteConfirm();
    },

    add: function(data) {
      this.saveFilter();
      if (this.namamenu=='procurement.vendor') {
        router.push({name :'procurement.vendorfrm'});
      } else {
        router.push({name :'payable.vendorfrm'});
      }
    },
    edit: function() {
      if (this.model.vendor_id) {
          this.saveFilter();
          if (this.namamenu=='procurement.vendor') {
            router.push({name :'procurement.vendorfrm', params: { vendor_id: this.model.vendor_id}});
          } else {
            router.push({name :'payable.vendorfrm', params: { vendor_id: this.model.vendor_id}});
          }
      } else {
            toastr.warn('Please select a row that want to be Edit!');
      }

    },
    deleteConfirm() {
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await vendor.remove(this.model);
      this.refresh();
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await vendor.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message, 'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error), 'ERROR MESSAGE',10000);
            }
        }
    },
    close(){
      router.push({path:"home"});
    },    

  }
};
</script>
